import React from "react";
import {ITicketReplayData} from "../../../contracts/data/ticket";
import {UserType} from "../../../constans/enumTypes";
import {generateMediaLink, generateUserTypeTitle, isNotEmpty} from "../../../helpers/functions";

const TicketReplyCard:React.FC<{data: ITicketReplayData}> = ({data}) => {
    return(
        <div className={`${data?.user_type === UserType.USER ? "bg-blue-100" : "bg-gray-100"} rounded-xl border ${data?.user_type === UserType.USER ? "border-blue-300" : "border-gray-300"} p-4 mb-4`}>
            <div className={"mb-3"}>{data?.content}</div>
            {data?.attachment && isNotEmpty(data?.attachment) && <div className={"mb-3"}><a href={generateMediaLink(data?.attachment)} target={"_blank"} className={"text-blue-400 underline text-sm"}>فایل پیوست شده</a></div>}
            <div className={"mt-3 flex flex-row justify-between items-center"}>
                <div className={"text-left text-gray-600 text-sm"}>{generateUserTypeTitle(data?.user_type)}</div>
                <div className={"text-left text-gray-600 text-sm"}>{data?.created_time_jalali}</div>
            </div>
        </div>
    )
}

export default TicketReplyCard